/* Pretty Panther — header steadiness.
   1. Compact header on scroll: the header gets shorter, so the page used to jump up (and back down when scrolling
      up). We keep the space the full header takes, so the page under it never moves.
   2. Menu dropdowns open on hover, also when the mouse is already resting on the menu when a page loads
      (no new "pointerenter" fires then, so the dropdown only opened after clicking).
   3. Touch screens: the first tap on "Brands" opens the dropdown, a second tap goes to the page.
   4. If the header changes size while a dropdown is open, the dropdown is re-measured so it doesn't jump or clip. */
(() => {
  if (window.__ppHeaderSteady) return;
  window.__ppHeaderSteady = true;
  const desktop = () => window.matchMedia('(min-width: 750px)').matches;
  const header = () => document.querySelector('#header-component');
  const stickyBox = () => header()?.closest('.shopify-section, header');

  let fullHeight = 0;
  const measure = (force) => {
    const h = header();
    if (!h) return;
    const box = stickyBox();
    const compact = document.body.classList.contains('pp-compact');
    // Ignore sizes while a dropdown or the search panel is open
    if (force !== true && (document.body.classList.contains('pp-search-open') || h.querySelector('.menu-list__link[aria-expanded="true"]'))) return;
    const height = h.getBoundingClientRect().height;
    if (!compact) {
      fullHeight = height;
      if (box) box.style.marginBottom = '';
    } else if (box && desktop() && fullHeight > height) {
      box.style.marginBottom = `${Math.round(fullHeight - height)}px`;
    }
  };

  const reopenActive = () => {
    const link = header()?.querySelector('.menu-list__link[aria-expanded="true"]');
    const item = link?.closest('.menu-list__list-item');
    if (!item) return;
    item.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
    requestAnimationFrame(() => item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false })));
  };

  const watchBody = () => {
    measure.last = document.body.classList.contains('pp-compact');
    new MutationObserver(() => {
      const now = document.body.classList.contains('pp-compact');
      if (measure.last === now) return;
      measure.last = now;
      measure(true);
      reopenActive();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  const setupMenu = () => {
    const h = header();
    if (!h || h.dataset.ppMenuFix) return;
    h.dataset.ppMenuFix = '1';
    new ResizeObserver(() => measure()).observe(h);
    measure();

    h.querySelectorAll('.menu-list__list-item').forEach((item) => {
      const link = item.querySelector(':scope > .menu-list__link');
      if (!link || link.getAttribute('aria-haspopup') !== 'true') return;

      // Mouse already on the item (e.g. right after a page load): open it on the first movement.
      item.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse' || link.getAttribute('aria-expanded') === 'true') return;
        item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
      });

      // Touch: first tap opens the dropdown, second tap follows the link.
      let lastPointer = 'mouse';
      link.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType; });
      link.addEventListener('click', (e) => {
        if (lastPointer === 'mouse' || !desktop()) return;
        if (link.dataset.ppTapped === '1') { delete link.dataset.ppTapped; return; }
        e.preventDefault();
        link.dataset.ppTapped = '1';
        item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
        setTimeout(() => { delete link.dataset.ppTapped; }, 4000);
      });
    });
  };

  const init = () => { watchBody(); setupMenu(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', () => measure());
  document.addEventListener('shopify:section:load', setupMenu);
})();
